import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Row, Col, Table, Button, Tooltip, OverlayTrigger, Glyphicon } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import MaritalStatusModalPage from '../../../containers/masters/MaritalStatus/MaritalStatusModalPage'

class MaritalStatusMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        nameDescription: null,
        code: null
      }
    }
  }

  componentDidUpdate () {
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchMaritalStatusList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchMaritalStatusList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  search () {
    this.props.actions.fetchMaritalStatusList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  handleNameDescriptionChange (nameDescription) {
    if (this.state.filter.nameDescription !== nameDescription) {
      this.setState({ filter: { ...this.state.filter, nameDescription } })
    }
  }

  handleCodeChange (code) {
    if (this.state.filter.code !== code) {
      this.setState({ filter: { ...this.state.filter, code } })
    }
  }

  resetFilters () {
    this.props.initialize({})
    this.props.reset()
    this.setState({
      filter: {
        code: null,
        nameDescription: null
      }
    })
    this.props.actions.fetchMaritalStatusList({ pageSize: 10 })
  }

  restart (maritalStatus) {
    maritalStatus.isEnabled = true
    this.props.actions.submitMaritalStatus(maritalStatus)
    this.resetFilters()
  }

  render () {
    const {
      t, maritalStatusList, pagesCount, maritalStatusListCount, filter,
      filter: { page },
      actions: { fetchMaritalStatusList, deleteMaritalStatus }
    } = this.props
    const tKey = 'MASTERS.MARITAL_STATUS_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t('MASTERS.RECOVER')}</Tooltip>)
    const hasFilters = (this.state.filter.nameDescription || this.state.filter.code)
    return (
      <div className="admin-wrapper">
        <MaritalStatusModalPage/>
        <Row className="section-users-header">
          <Col sm={12}>
            <div className="header-panel">
              <h4>{t(`${tKey}MARITAL_STATUS`)}</h4>
            </div>
          </Col>
        </Row>
        <Row>
          <div className="search-form">
            <span className="title-search"><i className="ico-search" /> {t(`${tKey}SEARCH_TITLE`)}</span>
            <Row>
              <Field
                name="filters.code"
                colSm={3}
                controlLabel={t(`${tKey}CODE`)}
                placeholder={t(`${tKey}CODE`)}
                component={InputText}
                onInputChange={(value) => this.handleCodeChange(value)}
              />
              <Field
                name="filters.nameDescription"
                colSm={3}
                controlLabel={t(`${tKey}NAME_DESCRIPTION`)}
                placeholder={t(`${tKey}NAME_DESCRIPTION`)}
                component={InputText}
                onInputChange={(value) => this.handleNameDescriptionChange(value)}
              />
              <Col sm={3} className="btn-wrapper" >
                <Button
                  className={'btn-white btn-input2 btn-white search-button'}
                  style={{ width: '100%', marginTop: '23px' }}
                  onClick={() => this.search()}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button style={{ marginTop: '23px' }}
                  className={'btn-icon btn-input ' + (hasFilters ? 'btn-standard' : 'btn-cancel')}
                  onClick={() => {
                    this.resetFilters()
                  }}>
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </Col>
            </Row>
          </div>
        </Row>
        <Col sm={12} className="col-row  section-users-body">
          <Table className="editable-table" hover responsive>
            <thead>
              <tr>
                <th onClick={() => { this.changeOrder('code') }}>
                  {t(`${tKey}CODE`)}
                  <i className={this.getSortIcon('code')} />
                </th>
                <th onClick={() => { this.changeOrder('name') }}>
                  {t(`${tKey}NAME`)}
                  <i className={this.getSortIcon('name')} />
                </th>
                <th onClick={() => { this.changeOrder('description') }}>
                  {t(`${tKey}DESCRIPTION`)}
                  <i className={this.getSortIcon('description')} />
                </th>
                <th style={{ width: '77px' }}>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
              </tr>
            </thead>
            <tbody>
              {maritalStatusList && maritalStatusList.map((maritalStatus, idx) => {
                return (
                  <tr key={idx} className={!maritalStatus.isEnabled ? 'is-deleted' : ''}>
                    <td>{maritalStatus.code}</td>
                    <td>{maritalStatus.name}</td>
                    <td>{maritalStatus.description}</td>
                    <td>
                      {maritalStatus.isEnabled ? (
                        <div className='flex row'>
                          <a onClick={() => this.props.actions.openEditMaritalStatusModal(maritalStatus)}>
                            <OverlayTrigger placement="right" overlay={editTooltip}>
                              <i className="ico-edit-white" />
                            </OverlayTrigger>
                          </a>
                          <a onClick={() => deleteMaritalStatus(maritalStatus.maritalStatusId)}>
                            <OverlayTrigger placement="left" overlay={deleteTooltip}>
                              <i className="ico-trash" />
                            </OverlayTrigger>
                          </a>
                        </div>
                      ) : (
                        <a onClick={() => this.restart(maritalStatus)}>
                          <OverlayTrigger placement="left" overlay={recoverTooltip}>
                            <Glyphicon glyph="repeat" />
                          </OverlayTrigger>
                        </a>
                      )}
                    </td>
                  </tr>)
              })
              }
              {(maritalStatusList === null || maritalStatusList === undefined || maritalStatusList.length === 0) &&
            <tr>
              <td colSpan={10}><h2>{t(`${tKey}RESULTS_NOT_FOUND`)}</h2></td>
            </tr>}
              <tr className="button-table-wrapper">
                <td>
                  <Button
                    className="btn-editable-table btn-standard"
                    onClick={() => this.props.actions.openMaritalStatusModal()}>
                  + {t(`${tKey}ADD`)}
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
          <div className="section-users-footer">
            <nav key={1} className="text-center">
              <IDocCarPagination
                id="btn_pag_sales"
                page={page}
                pagesCount={pagesCount}
                totalRows={maritalStatusListCount}
                onSelectAction={(value) => fetchMaritalStatusList({ ...filter, ...this.state.filter, page: value })}
              />
            </nav>
          </div>
        </Col>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listMaritalStatus'
})(MaritalStatusMaster)
